import { useLocation } from "react-router-dom-v5-compat";

/**
 * Return URL parameters
 */

export default () => {
	return new URLSearchParams(useLocation().search);
};
